import addMinutes from 'date-fns/add_minutes';

const setReduxPersistTimeout = (minutes = 10) =>
  addMinutes(new Date(), minutes);

export default setReduxPersistTimeout;
